var _circle, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    fill: "#B5B5B5",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3976_2135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9986 3.5L8.9248 3.75068V11.024L8.9986 11.0977L12.3748 9.102L8.9986 3.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99928 3.5L5.62305 9.102L8.99928 11.0977V7.56738V3.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99862 11.7368L8.95703 11.7875V14.3784L8.99862 14.4999L12.3768 9.74219L8.99862 11.7368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99928 14.4999V11.7368L5.62305 9.74219L8.99928 14.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99902 11.1006L12.3752 9.10493L8.99902 7.57031V11.1006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62305 9.10493L8.99928 11.1006V7.57031L5.62305 9.10493Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3976_2135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(3.5 3.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthIcon);
export default __webpack_public_path__ + "static/media/eth-icon.36a1c77b45bd9d9d2e2b2de0f071b812.svg";
export { ForwardRef as ReactComponent };